import * as React from 'react';
import { Modal, DatePicker, message, Button } from 'antd';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateInquiryDeadLine } from 'src/api/inquiry';
import * as LogRocket from 'logrocket';
import { tokens } from 'src/design-system';

class ExtendDeadlineModal extends React.PureComponent<any, any> {
  state: any = {
    selectedDeadline: null,
    isLoading: false,
    newDeadline: null,
  };

  componentDidMount() {
    const { deadline, timezone } = this.props;
    if (deadline) {
      // Convert deadline to organization timezone for display in date picker
      const deadlineMoment = timezone
        ? momentTimezone(deadline).tz(timezone)
        : moment(deadline);
      this.setState({
        selectedDeadline: deadlineMoment,
        newDeadline: deadlineMoment,
      });
    } else {
      this.setState({
        selectedDeadline: undefined,
        newDeadline: null,
      });
    }
  }

  disabledDate = (current: any) => {
    return current < moment(this.props.deadline).startOf('day')
      || current > moment(this.props.sailingDate).endOf('day');
  }

  changeInquiryDeadline = async (date, inquiryId, shipperId) => {
    this.setState({
      isLoading: true,
    });
    if (moment.isMoment(date)) {
      const response: any = await updateInquiryDeadLine({
        inquiryId,
        shipperId,
        updatedDeadline: {
          dateString: date.format('YYYY-MM-DD'),
          time: date.format('HH:mm'),
        },
      });
      if (response.isSuccess) {
        LogRocket.track('Inquiry Deadline Extended');
        this.props.handleOk(date);
      } else {
        message.error(response.errorMessage);
      }
    } else {
      message.error('Not a valid date.');
    }
    this.setState({
      isLoading: false,
    });

  }

  render() {
    const COLOR = {
      GREY: '#8C8C8C',
    };
    const dateFormat = 'YYYY/MM/DD hh:mm a';
    const { visible, handleCancel, deadline, inquiryId, shipperId, timezone } = this.props;
    const buttonProps =  { background: tokens.colors.primary, border: tokens.colors.primary };
    
    // Convert deadline to organization timezone for display
    const displayDeadline = deadline && timezone
      ? momentTimezone(deadline).tz(timezone)
      : deadline
      ? moment(deadline)
      : null;
    
    return (
      <Modal
        destroyOnClose={true}
        width="332px"
        title="Extend Deadline"
        visible={visible}
        onCancel={handleCancel}
        footer={[
          <Button key="back"
          style={{ marginLeft:'16%' }}
          onClick={handleCancel}>
            No
            </Button>,
          <Button key="submit" type="primary"
            loading={this.state.isLoading}
            style={{ background: tokens.colors.primary, border: tokens.colors.primary }}
            onClick={() => {
              this.changeInquiryDeadline(this.state.selectedDeadline, inquiryId, shipperId);
            }}>
            Yes
            </Button>,
        ]}
      >
        <span style={{ color: COLOR.GREY, fontSize: `${tokens.fontSize.small}px`, fontWeight: 'bold' }}>
          Previous Deadline</span><br />
        <DatePicker style={{ width: '100%' }} disabled
          format={dateFormat}
          showTime={{ use12Hours: true, format: 'h:mm:ss A' }}
          placeholder={displayDeadline ? displayDeadline.format(dateFormat) : 'Not Set'}
        /><br/>
        <span style={{ fontSize: `${tokens.fontSize.small}px`, fontWeight: 'bold' }}>New Deadline</span><br />
        <DatePicker style={{ width: '100%' }}
          allowClear={false}
          disabledDate={this.disabledDate}
          format={dateFormat}
          showTime={  { defaultValue : moment('18:00:00', 'HH:mm:ss') } }
          // placeholder={moment(deadline).format(dateFormat)}
          value={this.state.selectedDeadline}
          onChange={(selectedDeadline) => {
            this.setState({ selectedDeadline });
          }}
          onOk={(date) => {
            this.setState({ newDeadline : date });
          }}
        />
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  timezone: state.masterData.timezone,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  // changeInquiryDeadline,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(ExtendDeadlineModal);
